import { render, staticRenderFns } from "./SlotsStandingsTournament.vue?vue&type=template&id=a41f9cb8"
import script from "./SlotsStandingsTournament.vue?vue&type=script&lang=js"
export * from "./SlotsStandingsTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports